import React from 'react';

export function PrivacyContent() {
  return (
    <div className="space-y-6 text-gray-700 dark:text-gray-300 text-sm">
      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">1. Información que Recopilamos</h2>
        <p>Recopilamos información que usted nos proporciona directamente, como cuando crea una cuenta, participa en votaciones, o se comunica con nosotros. Esto puede incluir:</p>
        <ul className="list-disc list-inside space-y-2 mt-2">
          <li>Información de perfil (nombre, email, foto de perfil)</li>
          <li>Datos de votación y participación</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">2. Uso de la Información</h2>
        <p className="mb-2">Utilizamos su información para:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>Procesar y registrar sus votos</li>
          <li>Gestionar su cuenta y participación</li>
          <li>Mejorar nuestros servicios</li>
          <li>Enviar notificaciones sobre la votación</li>
          <li>Cumplir con obligaciones legales</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">3. Cookies y Tecnologías de Seguimiento</h2>
        <p className="mb-2">Utilizamos cookies y tecnologías similares para:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>Mantener su sesión activa</li>
          <li>Recordar sus preferencias</li>
          <li>Analizar el uso de la aplicación</li>
          <li>Mostrar contenido personalizado</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">4. Compartir Información</h2>
        <p className="font-semibold">NO compartimos su información personal con terceros bajo ninguna circunstancia. Su información permanece privada y segura en nuestra plataforma únicamente para el funcionamiento del servicio.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">5. Seguridad de Datos</h2>
        <p>Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">6. Sus Derechos</h2>
        <p className="mb-2">Usted tiene derecho a:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>Acceder a su información personal</li>
          <li>Corregir información inexacta</li>
          <li>Solicitar la eliminación de sus datos</li>
          <li>Oponerse al procesamiento de sus datos</li>
          <li>Retirar su consentimiento en cualquier momento</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">7. Retención de Datos</h2>
        <p>Conservamos su información personal solo durante el tiempo necesario para cumplir con los propósitos descritos en esta política, a menos que la ley requiera un período de retención más largo.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">8. Menores de Edad</h2>
        <p>Nuestros servicios no están dirigidos a menores de 13 años. No recopilamos intencionalmente información personal de menores de 13 años. Si cree que hemos recopilado información de un menor, contáctenos inmediatamente.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">9. Cambios a esta Política</h2>
        <p>Podemos actualizar esta política de privacidad ocasionalmente. Le notificaremos sobre cualquier cambio significativo publicando la nueva política en esta página y actualizando la fecha de "Última actualización".</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">10. Contacto</h2>
        <p>Si tiene preguntas sobre esta política de privacidad o nuestras prácticas de privacidad, contáctenos en: <a href="mailto:lagranjavota@gmail.com" className="text-violet-600 dark:text-violet-400 hover:underline">lagranjavota@gmail.com</a></p>
      </section>
    </div>
  );
}
